import { useCallback } from "react";
import { useParams } from "react-router-dom";

import { DefaultSheet } from "twyne-new.ui"

import { useAppAlert } from "@Components/AppAlert";
import history from "utils/history";

import Form from "../components/Form";
import { BuilderBlocksProvider, useBuilderBlocksStore } from "../store";

function BuilderBlocksForm() {
  const { id } = useParams()
  const { collection: { item, useLoad, useSubmit, reset } } = useBuilderBlocksStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)

  const handleSubmit = useSubmit()

  const handleClose = useCallback(() => {
    reset()
    history.push("/cms/builder-blocks")
  }, [reset])

  const handleSubmitAndRedirect = useCallback(async payload => {
    try {
      await handleSubmit(payload)
      const message = payload.id ? "edited" : "created"
      handleSuccess("Success", `Builder Block ${message}.`)
      handleClose()
    } catch (error) {
      handleError("Error", "Builder Block was not saved.");
    }
  }, [handleSubmit, handleClose, handleSuccess, handleError])

  if (!item) {
    return null;
  }

  return <DefaultSheet
    wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClose() }} contentProps={{ size: 'md' }}
    title={item.id ? "Edit Builder Block" : "Add Builder Block"}
  >
    <Form data={item} onSubmit={handleSubmitAndRedirect} onCancel={handleClose} />
  </DefaultSheet>
}

export default function BuilderBlocksFormLayout() {
  return <BuilderBlocksProvider>
    <BuilderBlocksForm />
  </BuilderBlocksProvider>
}
